import { Box, Container } from "@mui/material";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GasMeasure } from "../../../gas/modules/menu";
import {
    mainSlice,
    selectMainState,
    useDispatch,
    useSelector,
} from "../../../stateManagement/redux";
import { validateToken } from "../../../stateManagement/redux/slices/shared/asyncReducers";
import { DepartmentNameEnum } from "../../../stateManagement/redux/slices/shared/interfaces";
import { RigOptions } from "../../../subsuelo/modules/menu";
import { TanksOptions } from "../../../tanques/modules/menu";
import { GerenciaTecnicaOptions } from "../../../tecnica/modules/menu";
import { Header } from "../header";
import { ToastNotification } from "../ToastNotification";
import { Loading } from "./loading";
import { Login } from "./login";
import { RightMenuProjects } from "./right_menu_projects";
import "./style.scss";

export const WrapMain = ({ children }: { children: any }) => {
    const mainState = useSelector(selectMainState);

    useEffect(() => {
        if (!mainState.activeUser) {
            dispatch(validateToken());
        }

        if (
            localStorage.getItem("activeDepartmentId") &&
            !mainState?.activeDepartment
        ) {
            dispatch(
                mainSlice.actions.setDepartmentId(
                    localStorage.getItem(
                        "activeDepartmentId"
                    ) as DepartmentNameEnum
                )
            );
        }

        if (localStorage.getItem("activeProjectId")) {
            dispatch(
                mainSlice.actions.setActiveProjectId(
                    localStorage.getItem("activeProjectId") as string
                )
            );
        }
    }, []);

    const navigate = useNavigate();
    const location = useLocation();

    const dispatch = useDispatch();

    const onClickMenu = (path: string) => {
        dispatch(mainSlice.actions.setShowMenu());
        navigate(path);
    };

    if (!mainState.activeUser) {
        return (
            <Container maxWidth="xl" className="container">
                <ToastNotification />
                <Login />
            </Container>
        );
    }

    return (
        <>
            <ToastNotification />
            {mainState.loading && <Loading />}
            <Box>
                <Header />
                <div className="wrap-main__content">
                    <RightMenuProjects />
                    {mainState?.showMenu == true &&
                        mainState?.activeDepartmentId ===
                            DepartmentNameEnum.wellWhisper && (
                            <GerenciaTecnicaOptions onClick={onClickMenu} />
                        )}
                    {mainState?.showMenu == true &&
                        mainState?.activeDepartmentId ===
                            DepartmentNameEnum.rig && (
                            <RigOptions onClick={onClickMenu} />
                        )}
                    {mainState?.showMenu == true &&
                        mainState?.activeDepartmentId ===
                            DepartmentNameEnum.tanks && (
                            <TanksOptions onClick={onClickMenu} />
                        )}
                    {mainState?.showMenu == true &&
                        mainState?.activeDepartmentId ===
                            DepartmentNameEnum.gasMeasure && (
                            <GasMeasure onClick={onClickMenu} />
                        )}
                    <Box
                        className="wrap-main__content_body"
                        sx={{ width: "100%" }}
                    >
                        {children}
                    </Box>
                </div>
            </Box>
        </>
    );
};
